"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DollarCircleSpot = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DollarCircleSpot = _ref => {
  let {
    color = "#012D67",
    spotColor = "#FBD69B",
    strokeWidth = "1.6",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 24"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 10,
    fill: spotColor
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 14,
    cy: 11,
    r: 11,
    stroke: color,
    strokeWidth: 1.6
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: 0.2,
    d: "m14.683 10.526-.72-.355c-1.264-.62-1.502-.759-1.502-1.43 0-1.116 1.282-1.172 1.538-1.172.453 0 1.508.114 1.508 1.172a.73.73 0 0 0 1.461 0c0-1.334-.863-2.309-2.258-2.556v-.457a.73.73 0 0 0-1.46 0v.467C11.88 6.459 11 7.453 11 8.74c0 1.596 1.022 2.098 2.316 2.733l.721.357c1.264.62 1.502.759 1.502 1.43 0 1.042-1.077 1.154-1.539 1.154-.462 0-1.538-.112-1.538-1.155a.73.73 0 0 0-1.461 0c0 1.311.86 2.278 2.249 2.534v.478a.73.73 0 0 0 1.46 0v-.47c1.414-.244 2.29-1.214 2.29-2.542 0-1.596-1.022-2.098-2.317-2.734"
  })));
};
exports.DollarCircleSpot = DollarCircleSpot;
DollarCircleSpot.displayName = "DollarCircleSpot";